import { render, staticRenderFns } from "./DashboardProvider.vue?vue&type=template&id=02d4b4aa"
import script from "./DashboardProvider.vue?vue&type=script&lang=js"
export * from "./DashboardProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports